import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, ClipboardCheckIcon, MessagesSquareIcon, MoveUpRightIcon } from 'lucide-react';
const commitments = [{
  icon: ClipboardCheckIcon,
  title: 'Control de calidad',
  description: 'Supervisamos materiales, terminaciones y cada instancia clave de la ejecución.'
}, {
  icon: CalendarDaysIcon,
  title: 'Coordinación de obra',
  description: 'Organizamos equipos, proveedores y avances para sostener el ritmo de la obra.'
}, {
  icon: MessagesSquareIcon,
  title: 'Comunicación clara',
  description: 'Mantenemos a cada cliente informado para decidir con tranquilidad y a tiempo.'
}];
export function Construction() {
  return <section id="construccion" className="bg-white px-5 py-24 md:px-10 lg:py-32" aria-labelledby="construction-title" data-id="element-42" data-mp="19cwc6w4l0841">
      <div className="mx-auto max-w-[1440px]" data-id="element-43" data-mp="gtz2nxk6utzd">
        <div className="grid gap-6 lg:grid-cols-[1.12fr_.88fr] lg:gap-10" data-id="element-44" data-mp="gso206m1i2ch">
          <motion.figure initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="relative min-h-[470px] overflow-hidden bg-[#292724] md:min-h-[620px]" data-id="element-45" data-mp="2xvg7920cwvsg">
            <img src="https://cdn.magicpatterns.com/uploads/oYe3pq9DHmwrXVXfruYT2f/heylloyd-image-1783781167564.png" alt="Dos profesionales con casco revisando planos y señalando una obra en construcción" className="h-full w-full object-cover" data-id="element-46" data-mp="2a7gl6fdzptk7" />
            <figcaption className="absolute bottom-0 left-0 bg-[#F7F4EF] px-5 py-4 text-[10px] font-bold uppercase tracking-[.18em] text-[#5e5a55] md:px-7" data-id="element-47" data-mp="3gh4zmfr8fhz">
              Obra en marcha · Montevideo
            </figcaption>
          </motion.figure>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55,
          delay: 0.08
        }} className="flex flex-col justify-between bg-[#1A1A1A] p-8 text-white md:p-12" data-id="element-48" data-mp="1swjn2t0barxd">
            <div data-id="element-49" data-mp="2gm44h7gthh4j">
              <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#e9c8b6]" data-id="element-50" data-mp="2gmnnkri7ebk5">
                Construcción
              </p>
              <h2 id="construction-title" className="font-editorial mt-5 max-w-lg text-4xl leading-tight md:text-5xl" data-id="element-51" data-mp="26oq38f3gsywt">
                La precisión del proyecto, llevada a la obra
              </h2>
              <p className="mt-7 max-w-lg text-sm leading-7 text-white/70" data-id="element-52" data-mp="vbnlhgpmq3b2">
                En VC Estudio entendemos la construcción como una etapa central
                del proyecto. Trabajamos en obra para transformar las decisiones
                de diseño en resultados bien ejecutados, coordinados y pensados
                para perdurar.
              </p>
            </div>

            <a href="#contacto" className="mt-10 inline-flex w-fit items-center gap-2 border-b-2 border-[#C4724A] pb-2 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:border-[#e9c8b6] hover:text-[#e9c8b6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#e9c8b6]" data-id="element-53" data-mp="sqzf1unrf2e5">
              Hablemos de tu obra{' '}
              <MoveUpRightIcon size={15} aria-hidden="true" data-id="element-54" data-mp="9x3kqk2381me" />
            </a>
          </motion.div>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-[.72fr_1.28fr] lg:gap-10" data-id="element-55" data-mp="3icnbncfad7ya">
          <motion.figure initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="relative min-h-[250px] overflow-hidden bg-[#ded6ca]" data-id="element-56" data-mp="3dfn5z2mcm77p">
            <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1000&q=85" alt="Detalle de estructura y materiales durante una construcción" className="h-full w-full object-cover" data-id="element-57" data-mp="2zfj7e1rb7fe4" />
            <figcaption className="absolute bottom-4 left-4 bg-white px-3 py-2 text-[9px] font-bold uppercase tracking-[.16em] text-[#655f57]" data-id="element-58" data-mp="3deskuto4rvee">
              Seguimiento en sitio
            </figcaption>
          </motion.figure>

          <div className="grid border-l border-t border-[#e4ddd4] sm:grid-cols-3" aria-label="Compromisos de construcción" data-id="element-59" data-mp="1izygtc99sqya">
            {commitments.map(({
            icon: Icon,
            title,
            description
          }, index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            delay: index * 0.07
          }} className="min-h-[250px] border-b border-r border-[#e4ddd4] p-6 md:p-7" data-id="element-60" data-mp="16p7g7mojm61g" data-mpi={index}>
                <Icon size={23} strokeWidth={1.35} className="text-[#C4724A]" aria-hidden="true" data-id="element-61" data-mp="1gg240vhftdp0" />
                <h3 className="mt-12 text-sm font-bold" data-id="element-62" data-mp="4zljwouxu8vt">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-[#6c665f]" data-id="element-63" data-mp="6i2bas27elh7">
                  {description}
                </p>
              </motion.article>)}
          </div>
        </div>
      </div>
    </section>;
}